import { ResponseEntity } from "domain/entity/Common/ResponseEntity";
import { LetPassAccountEntity } from "domain/entity/LetPassAccount/LetPassAccountEntity";
import { LetPassAccountSearchCriteria } from "domain/entity/LetPassAccount/LetPassAccountSearchCriteria";
import { axiosPostData } from "../axios/AxiosBasicImpl";
import collectionAxiosInstance from "../axios/collectionAxiosInstance";
import { LetPassAccountRepository } from "./LetPassAccountRepo";

export const LetPassAccountRepoImpl = (): LetPassAccountRepository => {
    const url = '/v1/letPassAccount';

    const getEntities = async (searchCriteria: LetPassAccountSearchCriteria): Promise<LetPassAccountEntity[]> => {
        return axiosPostData(collectionAxiosInstance, url, searchCriteria).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            return [];
        });
    }

    const onSave = async (entity: LetPassAccountEntity): Promise<ResponseEntity> => {
        const saveUrl = '/v1/letPassAccountSave';
        return await axiosPostData(collectionAxiosInstance, saveUrl, entity);
    }

    const onPrintReport = async (ids: number[]): Promise<ResponseEntity> => {
        const printUrl = '/v1/letPassAccountPrintReport';
        return await axiosPostData(collectionAxiosInstance, printUrl, ids);
    }


    return {
        onSave: onSave,
        getEntities: getEntities,
        onPrintReport: onPrintReport,
    }
}